import { GetPageComponentViewModel } from '@/types/cml-api';
import { NavigationCarousel } from '@/features/carousel';
import { CarouselOptions } from '@/features/carousel/types';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import CarouselItem from './carousel-item';
import Skeleton from './skeleton';
import TilesType from './tiles-type';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
}
export function MobileCarouselDesktopTile({
  data,
  isLazy
}: Props) {
  const options: CarouselOptions = {
    mode: 'snap',
    perView: 1,
    loop: true,
    slides: {
      origin: 'center',
      perView: 1.3,
      spacing: 16
    }
  };
  const items = data.items?.at(0)?.items;
  const carouselItems = items?.map((item, index) => {
    const isLazyItem = isLazy || !PUBLIC_IS_BOT && index !== 0;
    return <CarouselItem key={item.id || item.link} isLazy={isLazyItem} {...item} sortKey={data?.sortKey} componentId={data?.id} index={index} />;
  });
  return <div className={deviceTypeClassGenerator(data.deviceTypes || '')} data-sentry-component="MobileCarouselDesktopTile" data-sentry-source-file="mobile-carousel-desktop-tile.tsx">
            <div className='homepage-container fit-screen relative min-h-[110px] md:hidden'>
                <NavigationCarousel options={options} skeleton={<Skeleton />} data-sentry-element="NavigationCarousel" data-sentry-source-file="mobile-carousel-desktop-tile.tsx">
                    {carouselItems}
                </NavigationCarousel>
            </div>
            <div className='homepage-container hidden md:block'>
                <TilesType items={items} isLazy={isLazy} sortKey={data?.sortKey} componentId={data?.id} data-sentry-element="TilesType" data-sentry-source-file="mobile-carousel-desktop-tile.tsx" />
            </div>
        </div>;
}